
import {
  ISelectedAnalys,
  ISelectedAnalysCodePrivilege,
} from '../../../../EkonomiskAnalysPage';
import { EDAutoCompleteEdit } from '../../../../../../../../../BaseComponents/AutoCompleteEdit/EDAutoCompleteEdit';

interface IProps {
  kodbehorighetNamn?: string;
  anvandsFor: string[];
  updateImpersonatedCodePrivilege: (
    codePrivilege?: ISelectedAnalysCodePrivilege
  ) => void;
  codePrivileges: ISelectedAnalysCodePrivilege[];
  selectedAnalys: ISelectedAnalys;
  onChange: () => void;
  onBlur: () => void;
  disableArrowIcon?: boolean;
}

const getCodePrivFromName = (
  name: string,
  codePrivileges: ISelectedAnalysCodePrivilege[]
): ISelectedAnalysCodePrivilege | undefined => {
  return codePrivileges.find(codePriv => codePriv.name === name);
};

const EkonomiskAnalysKodbehorighetMenu = (props: IProps) => {
  const { codePrivileges, onChange, onBlur, disableArrowIcon } = props;
  const updateImpersonatedCodePrivilege = (
    codePrivilege: ISelectedAnalysCodePrivilege | null
  ) => {
    const code =
      codePrivilege?.name === props.selectedAnalys.codePrivilege.name
        ? undefined
        : codePrivilege ?? undefined;
    props.updateImpersonatedCodePrivilege(code);
    onChange();
  };

  return (
    <EDAutoCompleteEdit<ISelectedAnalysCodePrivilege>
      autoFocus
      disableArrowIcon={disableArrowIcon}
      fullWidth
      getOptionLabel={options => options.name}
      inputMargin="none"
      label="Kodbehörighet"
      options={codePrivileges}
      onChange={updateImpersonatedCodePrivilege}
      onBlur={onBlur}
      value={
        props.kodbehorighetNamn
          ? getCodePrivFromName(props.kodbehorighetNamn, codePrivileges)
          : undefined
      }
    />
  );
};

export default EkonomiskAnalysKodbehorighetMenu;
